export type GraphQLErrorResponse = {
  errors?: {
    message: string;
    extensions: { code: string };
    path: string[];
  }[];
};

export class RequestError extends Error {
  response?: globalThis.Response;

  constructor(message: string, response?: globalThis.Response) {
    super(message);
    this.name = 'RequestError';
    this.response = response;

    Error.captureStackTrace(this, RequestError);
  }
}

export class GraphQLClientError extends Error {
  constructor(message: string, options?: { cause?: Error }) {
    super(message, options);
    this.name = 'GraphQLClientError';

    Error.captureStackTrace(this, GraphQLClientError);
  }
}
